/**
 * The pieces of the demo that belong to no single screen.
 *
 * The file viewer and the facilities bar are opened by code on other pages —
 * a row in a register offers its attachment, a facility page shows the bar —
 * so the elements have to exist for the whole session rather than per route.
 * They are hidden by the stylesheet until something opens them.
 *
 * The modal that detail sheets open into is next door in DemoGateway, for the
 * same reason.
 */
import { useEffect, useRef } from "react";
import { whenDemoLoaded } from "./domain/load";
import { attachExplain } from "./lib/explain";
import { t } from "../i18n";
import "./styles/demo.css";

export function DemoChrome() {
  const bar = useRef<HTMLDivElement | null>(null);

  /* every "where this comes from" affordance, wherever a screen renders it */
  useEffect(attachExplain, []);

  useEffect(() => {
    /* facBar fills the bar with the places — the map, the buildings, landside —
       rather than every register, which is what made two pages feel like one
       page twice */
    /* the argument is which place is currently open; nothing is, on mount */
    /* the bar is hidden until a facility page shows it, and that page is a
       demo screen — which brings the domain with it */
    if (bar.current) whenDemoLoaded((d) => d.facBar(null));
  }, []);

  return (
    <>
      {/* images and PDFs render here, text is printed, anything else offers the
          download; viewFile() fills it */}
      <div id="fileview">
        <div className="fvbox">
          <div className="fvhead">
            <div>
              <b id="fvName"></b>
              <small id="fvMeta"></small>
            </div>
            <a
              className="btn"
              id="fvGet"
              href="#"
              download
              style={{ width: "auto", margin: 0, padding: "6px 12px", textDecoration: "none" }}
            >
              {t("GET THE FILE")}
            </a>
            <button className="close" id="fvX">
              {t("CLOSE")}
            </button>
          </div>
          <div className="fvbody" id="fvBody"></div>
        </div>
      </div>

      <div id="facbar" ref={bar}>
        <span className="faclab">{t("AIRPORT FACILITIES")}</span>
        <div className="facbtns" id="facBtns"></div>
        <button className="facclose" id="facHub">
          {t("ALL FACILITIES")}
        </button>
        <button className="facback" id="facBack">
          <i>←</i>
          <span id="facBackLab">{t("BACK")}</span>
        </button>
      </div>
    </>
  );
}
